export default function AboutSection() {
  return (
    <section id="about" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-black text-foreground-900 mb-3">关于我们</h2>
            <p className="text-foreground-500 text-sm max-w-xl mx-auto">了解91黑料网的使命与愿景</p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 items-start">
            <div className="lg:col-span-2">
              <div className="relative w-full aspect-square rounded-2xl overflow-hidden border border-background-200/60">
                <img
                  src="https://readdy.ai/api/search-image?query=Dark%20elegant%20editorial%20office%20with%20warm%20amber%20lighting%2C%20premium%20brand%20identity%20photography%2C%20mysterious%20cinematic%20atmosphere%2C%20deep%20shadows%20with%20warm%20highlights%2C%20abstract%20composition%2C%20professional%20aesthetic%2C%20no%20text%2C%20no%20people&width=600&height=600&seq=about-91hlw&orientation=squarish"
                  alt="91黑料网 - 关于我们"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>

            <div className="lg:col-span-3">
              <div className="space-y-4">
                <p className="text-sm text-foreground-600 leading-relaxed">
                  91黑料网成立于2020年，是国内领先的黑料视频聚合与资讯内容平台。我们致力于为用户提供
                  最新、最全的黑料视频合集与在线观看服务，涵盖娱乐圈、网红圈、体育圈、科技圈、直播圈等
                  多个领域。
                </p>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  平台每日更新最新黑料短视频，所有内容均经过严格审核与多方验证，确保为用户呈现
                  真实可靠的黑料视频内容。91黑料网始终秉持客观中立的立场，不偏不倚地报道每一件
                  爆料事件，让读者能够全面了解事件真相。
                </p>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  截至目前，91黑料网已累计收录数万条黑料视频内容，日均活跃用户超过百万。我们
                  持续优化平台体验，推出移动端应用，让用户随时随地都能流畅观看黑料视频在线播放。
                  未来，我们将继续拓展内容覆盖范围，为更多用户提供优质的黑料视频观看服务。
                </p>
              </div>

              <div className="grid grid-cols-3 gap-4 mt-8">
                <div className="text-center p-4 bg-background-50 rounded-xl border border-background-200/60">
                  <div className="text-2xl font-black text-primary-500">3年+</div>
                  <div className="text-xs text-foreground-500 mt-1">稳定运营</div>
                </div>
                <div className="text-center p-4 bg-background-50 rounded-xl border border-background-200/60">
                  <div className="text-2xl font-black text-accent-500">100万+</div>
                  <div className="text-xs text-foreground-500 mt-1">日均用户</div>
                </div>
                <div className="text-center p-4 bg-background-50 rounded-xl border border-background-200/60">
                  <div className="text-2xl font-black text-secondary-600">数万条</div>
                  <div className="text-xs text-foreground-500 mt-1">黑料视频</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}